"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _localeProvider = require("@alicd/next/lib/locale-provider");

var _localeProvider2 = _interopRequireDefault(_localeProvider);

var _RangePicker = require("./RangePicker");

var _RangePicker2 = _interopRequireDefault(_RangePicker);

var _locale = require("@alicd/next/lib/_components/@alicd/next-date-picker/lib/locale");

var _locale2 = _interopRequireDefault(_locale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateRangePickerWithLocale = (0, _localeProvider2.default)(_RangePicker2.default);
DateRangePickerWithLocale.LOCALE = _locale2.default;
DateRangePickerWithLocale.ranges = _RangePicker.ranges;

exports.default = DateRangePickerWithLocale;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-date-range-picker@0.0.3@@alicd/crui-date-range-picker/lib/index.js
// module id = 265
// module chunks = 0